import React, { useCallback, FC } from "react";
import { useModalDispatch } from "@/context/ModalContext";
import RightArrow from "@/SvgIcons/RightArrow";
import { IModalActions, ModalTypes } from "@/types/modal";
import styles from "./mobile-menu.module.scss";
import ClientSideButton from "@/components/molecules/Carousels/HeroCarousel/ClientSideButton";
import popupData from "@/data/popup-data.json";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";
import { GA_EVENTS, GAEvent } from "@/helpers/gaEvents";
import { AssociatedProgramInterface } from ".";
import { FREEZE_RFIS } from "./utils";
import { usePathname } from "next/navigation";
interface MenuCTAProps {
  isSponsoredCertificates: boolean;
  associatedPrograms: AssociatedProgramInterface[];
}

const MenuCTA: FC<MenuCTAProps> = ({ isSponsoredCertificates,associatedPrograms }) => {
  const modalDispatch = useModalDispatch();
  const { LEAD_INITIATE } = GAEvent;
  const pathname = usePathname();

  const studentLoginHandler = useCallback(() => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.LoginModal,
      },
    });

    setTimeout(() => {
      pushToDataLayer({
        event: "student_login_initiate",
        cta_text: "STUDENT LOGIN",
        page_type: getGlobalStateValue("pageType"),
        page_url: location.href,
      });
    }, 2500);
  }, [modalDispatch]);

  return (
    <div className={styles.studentCTA}>
      <button onClick={studentLoginHandler} className={styles.studentLogin} aria-label="Existing Student Login">
        Existing Student Login <RightArrow stroke="#1a325d" />
      </button>

      {!FREEZE_RFIS.includes(pathname) && <ClientSideButton
        modalType={
          isSponsoredCertificates
            ? ModalTypes.ConnectModalFormSponsoredCourses
            : ModalTypes.ConnectModal
        }
        GADataNew={{
          ...GA_EVENTS.get(LEAD_INITIATE),
          cta_text: "Apply Now",
          section_name: "Header",
          header_title: "NA",
          isPageType: true,
          page_url: true,
        }}
        webEngageEvents={{
          "Section Name": "Header",
          isPageType: true,
           eventName: "Apply Now Clicked"
        }}
        modalData={{
          associatedPrograms,
          isLandingPage: true,
          popup: popupData,
        }}
        ctaText={isSponsoredCertificates ? "ENROLL NOW" : "APPLY NOW"}
        className={styles.mobileApplyNowBtn}
        styles={{
          background: "#1A325D",
          color: "#fff"
        }}
      />}
    </div>
  );
};

export default MenuCTA;
